import { FC, useState } from "react"
import { Box } from "@chakra-ui/react";
import { useDndAsset } from "domains/drag-and-drop";
import { TextQuickActions } from "./textQuickActions";
import { DisplayTextAsset } from "./displayTextAsset";
import { TextAssetWrapper } from "./textAssetWrapper";

export const TextAsset: FC<{ isEditable: boolean }> = ({ isEditable }) => {
  const { asset } = useDndAsset();
  const [ isActive, setIsActive ] = useState(false);

  if (!asset) {
    return null;
  }

  return (
    <TextAssetWrapper setIsActive={setIsActive}>
      <DisplayTextAsset asset={asset} />
      { isEditable && (
        <Box position="absolute" top="0px" right="10px" translateY="-50%">
          <TextQuickActions isActive={isActive} />
        </Box>
      )}
    </TextAssetWrapper>
  )
};
